/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ModuleContext } from '../../models/module-context';
import { PersonsAuthorizationCriteriaExplainResult } from '../../models/persons-authorization-criteria-explain-result';

export interface GetExplainUserAccess$Plain$Params {
  companyId: string;
  userId: string;
  personId?: string;
  personEmail?: string;
  includeDeleted?: boolean;
  includeThirdPartyUser?: boolean;
  module?: ModuleContext;
}

export function getExplainUserAccess$Plain(http: HttpClient, rootUrl: string, params: GetExplainUserAccess$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonsAuthorizationCriteriaExplainResult>> {
  const rb = new RequestBuilder(rootUrl, getExplainUserAccess$Plain.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.path('userId', params.userId, {});
    rb.query('personId', params.personId, {});
    rb.query('personEmail', params.personEmail, {});
    rb.query('includeDeleted', params.includeDeleted, {});
    rb.query('includeThirdPartyUser', params.includeThirdPartyUser, {});
    rb.query('module', params.module, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PersonsAuthorizationCriteriaExplainResult>;
    })
  );
}

getExplainUserAccess$Plain.PATH = '/company/{companyId}/explainAccess/{userId}';
